<template>
  <vueCropper height="562px"
              ref="cropper" :img="imgUrl"
              :outputSize="option.size"
              :outputType="option.outputType"
              :info="true" :guides="true"
              :high='option.high'
              :fixed="true"
              :full="option.full"
              :canMove="option.canMove"
              :canMoveBox="option.canMoveBox"
              :original="option.original"
              :autoCrop="option.autoCrop"
              :autoCropWidth="option.autoCropWidth"
              :autoCropHeight="option.autoCropHeight"
              :fixedBox="option.fixedBox"
              :fixedNumber="option.fixedNumber"
              :maxImgSize="option.maxImgSize"
              @realTime="realTime"
              :infoTrue="option.infoTrue"
              @imgLoad="imgLoad">
  </vueCropper>
</template>
<script>
// 引入组件
import { VueCropper } from 'vue-cropper'

export default {
  components: {
    VueCropper
  },
  props: {
    imgUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      option: {
        img: '',//裁剪图片的地址
        size: 1,// 裁剪生成图片的质量
        full: true,
        outputType: 'jpeg',//裁剪生成图片的格式
        canMove: true,//可以拖动图片
        original: false,
        canMoveBox: true,//可以拖动截图框
        autoCrop: true,// 是否默认生成截图框
        high: true,
        autoCropWidth: 320,// 默认生成截图框宽度
        autoCropHeight: 311,// 默认生成截图框高度
        fixedBox: false,
        infoTrue: false,
        downImg: '#',
        fixed: false,//是否开启截图框宽高固定比例
        fixedNumber: [5, 4.9],
        maxImgSize: 30000 // 图片最大像素
      }
    }
  },
  mounted() {

  },
  methods: {
    realTime(data) {
      // 实时预览函数
      let imgAxis = this.$refs.cropper.getImgAxis()
      let cropAxis = this.$refs.cropper.getCropAxis()
      let cropImgX = cropAxis.x1 - imgAxis.x1
      let cropImgY = cropAxis.y1 - imgAxis.y1
      data.x = cropImgX
      data.y = cropImgY
      // 把数据返给父组件		
      this.$refs.cropper.getCropData(data => {
        this.$emit('getBlobUrl', data)
      })
    },
    imgLoad(msg) {
      this.getLogUtils().logWithTag('imgLoad', msg)
    }
  }
}
</script>
<style scoped>
</style>